<template>
  <v-card class="elevation-0">
    <v-toolbar card dense color="transparent">
      <v-toolbar-title><h4>Уведомления</h4></v-toolbar-title>
    </v-toolbar>
    <v-divider></v-divider>
    <v-card-text class="pa-0">
      <v-list two-line class="pa-0">
        <template v-for="(item, index) in logNotification">
          <v-subheader v-if="item.procedureName" :key="item.id">Процедура: {{ item.procedureName }}</v-subheader>
          <v-divider  ></v-divider>
          <v-list-tile avatar @click="handleClick">
            <v-list-tile-avatar color="red">
              <v-icon   dark>error</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-sub-title v-html="item.errormsgStr"></v-list-tile-sub-title>
            </v-list-tile-content>
            <v-list-tile-action class="caption">
              {{item.lastModified}}
            </v-list-tile-action>
          </v-list-tile>
        </template>
      </v-list>
      <v-divider></v-divider>
      <v-btn block flat class="ma-0" href="#/dev/log" >Просмотреть все</v-btn>
      <v-btn v-if="logNotification.length > 0" block flat class="ma-0" @click="clearNotification()">Очистить</v-btn>
      <v-divider></v-divider>
    </v-card-text>
  </v-card>
</template>

<script>
//import notes from '@/api/notification';
export default {
  data () { return {

      newLogError: {},
    }
  },
  computed: { 
      logNotification() {  
        this.newLogError = this.$store.getters['log/logData'].filter(item => this.$store.getters['log/logFirstData'].findIndex(iItem => iItem.id == item.id)  == -1 );
        this.newLogError =  this.newLogError.filter(item => item.typeLogId == 1);
        return this.newLogError;
      }
  },
  methods: {
    handleClick: (e) => {
      console.log(e);
    },
    clearNotification(){
      this.newLogError = [];
      this.$store._actions["log/setIsFirst"][0]();
    }
  },

};
</script>



// WEBPACK FOOTER //
// src/components/widgets/list/NotificationList.vue